import { render } from "./PageError404.vue?vue&type=template&id=2e5435a8&scoped=true"
const script = {}

import "./PageError404.vue?vue&type=style&index=0&id=2e5435a8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e5435a8"]])

export default __exports__